export default (clientHttp, apiVersion) => ({
  create(id, params) {
    return clientHttp.post(`${apiVersion}/user/houses/${id}/calendar_imports`, {
      ...params,
    })
  },
})
